<template>
  <div>
    <fieldset class="border p-2">
      <legend>
        <small style="font-size:15px; font-weight: bold">new truck allocation</small>
      </legend>
      <div>
        <div class="row">
          <div class="col-md-12">
            <fieldset class="border p-3">
              <div class="row">
                <div class="col-md-4">
                  <label style="font-size:13px; font-weight: bold">Customer name:</label>
                  <span style="font-size:13px;">{{Bond.customer_name}}</span>
                </div>
                <div class="col-md-4">
                  <label style="font-size:13px; font-weight: bold">Cargo no:</label>
                  <span style="font-size:13px;">{{Bond.container_no}}</span>
                </div>
                <div class="col-md-4">
                  <label style="font-size:13px; font-weight: bold">T812 entry:</label>
                  <span style="font-size:13px;">{{Bond.t812_entry}}</span>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
      <p></p>
      <p></p>
      <form @submit.prevent="newRequisition()">
        <div class="row">
          <div class="col-md-12">
            <input type="hidden" class="bond_id" :value="Bond.id" />
            <input type="hidden" class="cargo_id" :value="Bond.cargo_id" />
            <div class="form-group">
              <label>Transporter</label>
              <select
                class="form-control transporter_id input-rounded f-s-14"
                @change="loadTransportertrucks()"
                required
              >
                <option>Select transporter</option>
                <option
                  v-for="transporter in systemTransporter"
                  :value="transporter.id"
                  :key="transporter.id"
                >{{ transporter.transporter_name }}</option>
              </select>
            </div>
            <table class="table table-striped table-hover">
              <thead>
                <tr>
                  <th></th>
                  <th>id</th>
                  <th>Truck no</th>
                  <th>Trailer no</th>
                  <th>Driver name</th>
                  <th>Driver phone</th>
                  <th>Id number</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="transporters  in systemTransportertrucks" :key="transporters.id">
                  <td>
                    <label class="form-checkbox">
                      <input
                        type="checkbox"
                        class="truck_id"
                        :value="transporters.id"
                        v-model="selectedItems"
                        :disabled="selectedItems.length >= 1 && selectedItems.indexOf(transporters.id) == -1"
                        required
                      />
                      <i class="form-icon"></i>
                    </label>
                  </td>
                  <td>{{transporters.id}}</td>
                  <td>{{transporters.truck_no}}</td>
                  <td>{{transporters.trailer_no}}</td>
                  <td>{{transporters.driver_name}}</td>
                  <td>{{transporters.driver_phone}}</td>
                  <td>{{transporters.driver_id_number}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-12">
            <label>Loading date</label>
            <input
              type="date"
              class="form-control loading_date input-rounded f-s-14"
              placeholder="loading date"
              required
            />
          </div>
          <div class="col-md-12">
            <label>Port/cfs</label>
            <input
              type="date"
              class="form-control port_cfs input-rounded f-s-14"
              placeholder="out of port/cfs date"
              required
            />
          </div>
        </div>
        <p></p>
         <button type="submit" class="btn btn-primary btn-flat creatingRequisition btn-rounded">
            <i class="fa fa-truck"></i> Add truck
          </button>
          <button type="button" class="btn btn-info btn-flat creatingRequisitionLoader btn-rounded">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
          </button>
      </form>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import $ from "jquery";
import router from "../router/index";
export default {
  data() {
    return {
      selectedItems: []
    };
  },

  created() {
    if (this.$store.getters.Bond.length === 0) {
      router.push("/managebonds");
    }
    this.loadTransportertrucks();
    this.loadTransporter();
  },
  computed: {
    ...mapGetters(["Bond", "systemTransportertrucks", "systemTransporter"])
  },
  methods: {
    ...mapActions(["loadTransportertrucks", "loadTransporter", "newRequisition"])
  }
};
</script>
<style scoped>
.creatingRequisitionLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/requisitions/requisition.vue